module.exports = __webpack_public_path__ + "img/button_news_off.fe31aaa3.png";